//general routes
export const HOME_ROUTE_NAME = 'home';
export const MANUFACTURING_PROCESS_ROUTE = { name: 'manufacturing-process' };
export const MANUFACTURING_PROCESS_ROUTE_NAME = 'manufacturing-process';
export const TECH_MEASURES_ROUTE = 'tech-measures';
export const TECH_MEASURES_WITH_TYPE_ROUTE_NAME = 'tech-measures-list';
export const RENEWABLE_ENERGY_ROUTE_NAME = 'renewable-energy';

//detail routes
export const TECH_MEASURE_DETAIL_ROUTE_NAME = 'tech-measure-detail';
export const ENERGY_AND_WATER_DETAIL_ROUTE_NAME = 'energy-water';
export const ENERGY_DETAIL_ROUTE_NAME = 'energy';
export const WATER_DETAIL_ROUTE_NAME = 'water';
export const WASTEWATER_DETAIL_ROUTE_NAME = 'wastewater';
export const TECH_MEASURE_DETAIL_ROUTES_NAMES = [
  ENERGY_AND_WATER_DETAIL_ROUTE_NAME,
  ENERGY_DETAIL_ROUTE_NAME,
  WATER_DETAIL_ROUTE_NAME,
  WASTEWATER_DETAIL_ROUTE_NAME
];
